export default __webpack_public_path__ + "static/media/element_24.d1d43cec.webp";